import React from "react";
import { Link } from "react-router-dom";

const HomePage = () => {
  return (
    <div className="homepage-container">
      <h1>WELCOME TO MPO</h1>
      <Link to="/kanban" className="kanban-link">
        <button className="report-wizard-button button-preview">
          Go to Kanban Page
        </button>
      </Link>
    </div>
  );
};

export default HomePage;